export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';
